export const actionTypes = {
  // UIGP OTP
  GENERATE_UIGP_OTP: "GENERATE_UIGP_OTP",
  GENERATE_UIGP_OTP_SUCCESS: "GENERATE_UIGP_OTP_SUCCESS",
  GENERATE_UIGP_OTP_FAILURE: "GENERATE_UIGP_OTP_FAILURE",
  VERIFY_UIGP_OTP: "VERIFY_UIGP_OTP",
  VERIFY_UIGP_OTP_SUCCESS: "VERIFY_UIGP_OTP_SUCCESS",
  VERIFY_UIGP_OTP_FAILURE: "VERIFY_UIGP_OTP_FAILURE",
  VERIFY_CHANGE_MOBILE_EMAIL_OTP: "VERIFY_CHANGE_MOBILE_EMAIL_OTP",
  VERIFY_CHANGE_MOBILE_EMAIL_OTP_SUCCESS:
    "VERIFY_CHANGE_MOBILE_EMAIL_OTP_SUCCESS",
  VERIFY_CHANGE_MOBILE_EMAIL_OTP_FAILURE:
    "VERIFY_CHANGE_MOBILE_EMAIL_OTP_FAILURE",

  // ARCOT OTP
  VERIFY_ARCOT_OTP: "VERIFY_ARCOT_OTP",
  VERIFY_ARCOT_OTP_SUCCESS: "VERIFY_ARCOT_OTP_SUCCESS",
  VERIFY_ARCOT_OTP_FAILURE: "VERIFY_ARCOT_OTP_FAILURE",
  VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR:
    "VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR",
  VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR_SUCCESS:
    "VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR_SUCCESS",
  VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR_FAILURE:
    "VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR_FAILURE",

  // SECURITY QUESTIONS
  GET_CHANGE_MOBILE_SEC_QUESTIONS: "GET_CHANGE_MOBILE_SEC_QUESTIONS",
  GET_CHANGE_MOBILE_SEC_QUESTIONS_SUCCESS:
    "GET_CHANGE_MOBILE_SEC_QUESTIONS_SUCCESS",
  GET_CHANGE_MOBILE_SEC_QUESTIONS_FAILURE:
    "GET_CHANGE_MOBILE_SEC_QUESTIONS_FAILURE",
  VERIFY_CHANGE_MOBILE_SEC_QUESTIONS: "VERIFY_CHANGE_MOBILE_SEC_QUESTIONS",
  VERIFY_CHANGE_MOBILE_SEC_QUESTIONS_SUCCESS:
    "VERIFY_CHANGE_MOBILE_SEC_QUESTIONS_SUCCESS",
  VERIFY_CHANGE_MOBILE_SEC_QUESTIONS_FAILURE:
    "VERIFY_CHANGE_MOBILE_SEC_QUESTIONS_FAILURE",

  // TEMP TOKEN
  GET_TEMP_TOKEN_REQUEST: "GET_TEMP_TOKEN_REQUEST",
  GET_TEMP_TOKEN_REQUEST_SUCCESS: "GET_TEMP_TOKEN_REQUEST_SUCCESS",
  GET_TEMP_TOKEN_REQUEST_FAILURE: "GET_TEMP_TOKEN_REQUEST_FAILURE",

  // PASSWORD STUFF
  GET_PASSWORD_POLICY: "GET_PASSWORD_POLICY",
  GET_PASSWORD_POLICY_SUCCESS: "GET_PASSWORD_POLICY_SUCCESS",
  GET_PASSWORD_POLICY_FAILURE: "GET_PASSWORD_POLICY_FAILURE",
  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_REQUEST_SUCCESS: "CHANGE_PASSWORD_REQUEST_SUCCESS",
  CHANGE_PASSWORD_REQUEST_FAILURE: "CHANGE_PASSWORD_REQUEST_FAILURE",
};

// UIGP OTP
export const generateUigpOtpAction = (payload: any) => ({
  type: actionTypes.GENERATE_UIGP_OTP,
  payload,
});
export const generateUigpOtpActionSuccess = (payload: any) => ({
  type: actionTypes.GENERATE_UIGP_OTP_SUCCESS,
  payload,
});
export const generateUigpOtpActionFailure = (payload: any) => ({
  type: actionTypes.GENERATE_UIGP_OTP_FAILURE,
  payload,
});
export const verifyUigpOtpAction = (payload: any) => ({
  type: actionTypes.VERIFY_UIGP_OTP,
  payload,
});
export const verifyUigpOtpActionSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_UIGP_OTP_SUCCESS,
  payload,
});
export const verifyUigpOtpActionFailure = (payload: any) => ({
  type: actionTypes.VERIFY_UIGP_OTP_FAILURE,
  payload,
});
export const verifyChangeMobileEmailOtpAction = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_EMAIL_OTP,
  payload,
});
export const verifyChangeMobileEmailOtpActionSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_EMAIL_OTP_SUCCESS,
  payload,
});
export const verifyChangeMobileEmailOtpActionFailure = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_EMAIL_OTP_FAILURE,
  payload,
});

// ARCOT OTP
export const verifyArcotOtpAction = (payload: any) => ({
  type: actionTypes.VERIFY_ARCOT_OTP,
  payload,
});
export const verifyArcotOtpActionSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_ARCOT_OTP_SUCCESS,
  payload,
});
export const verifyArcotOtpActionFailure = (payload: any) => ({
  type: actionTypes.VERIFY_ARCOT_OTP_FAILURE,
  payload,
});
export const verifyChangeMobileCaOtpAction = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR,
  payload,
});
export const verifyChangeMobileCaOtpActionSuccess = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR_SUCCESS,
  payload,
});
export const verifyChangeMobileCaOtpActionFailure = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_CA_AUTHENTICATOR_FAILURE,
  payload,
});

// SECURITY QUESTIONS (Change mobile)
export const getChangeMobileSecurityQuestionsAction = () => ({
  type: actionTypes.GET_CHANGE_MOBILE_SEC_QUESTIONS,
});
export const getChangeMobileSecurityQuestionsActionSuccess = (
  payload: any
) => ({
  type: actionTypes.GET_CHANGE_MOBILE_SEC_QUESTIONS_SUCCESS,
  payload,
});
export const getChangeMobileSecurityQuestionsActionFailure = (
  payload: any
) => ({
  type: actionTypes.GET_CHANGE_MOBILE_SEC_QUESTIONS_FAILURE,
  payload,
});
export const verifyChangeMobileSecurityQuestionsAction = (payload: any) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_SEC_QUESTIONS,
  payload,
});
export const verifyChangeMobileSecurityQuestionsActionSuccess = (
  payload: any
) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_SEC_QUESTIONS_SUCCESS,
  payload,
});
export const verifyChangeMobileSecurityQuestionsActionFailure = (
  payload: any
) => ({
  type: actionTypes.VERIFY_CHANGE_MOBILE_SEC_QUESTIONS_FAILURE,
  payload,
});

// TEMP TOKEN
export const getTempTokenAction = (payload: any) => ({
  type: actionTypes.GET_TEMP_TOKEN_REQUEST,
  payload,
});
export const getTempTokenActionSuccess = (payload: any) => ({
  type: actionTypes.GET_TEMP_TOKEN_REQUEST_SUCCESS,
  payload,
});
export const getTempTokenActionFailure = (payload: any) => ({
  type: actionTypes.GET_TEMP_TOKEN_REQUEST_FAILURE,
  payload,
});

// PASSWORD STUFF
export const getPwdPolicyAction = (payload: any) => ({
  type: actionTypes.GET_PASSWORD_POLICY,
  payload,
});
export const getPwdPolicyActionSuccess = (payload: any) => ({
  type: actionTypes.GET_PASSWORD_POLICY_SUCCESS,
  payload,
});
export const getPwdPolicyActionFailure = (payload: any) => ({
  type: actionTypes.GET_PASSWORD_POLICY_FAILURE,
  payload,
});
export const changePwdRequestAction = (payload: any) => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST,
  payload,
});
export const changePwdRequestActionSuccess = (payload: any) => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST_SUCCESS,
  payload,
});
export const changePwdRequestActionFailure = (payload: any) => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST_FAILURE,
  payload,
});
